module.exports = __webpack_public_path__ + "img/mg.0f6d33e2.png";